import { createSelector } from 'reselect';

const slice = (state) => (state && state.accessRequests) || {};

export const incomingAccessRequestsSelector = createSelector(
  slice,
  (s) => s.incomingPending || []
);

export const incomingDecidedAccessSelector = createSelector(
  slice,
  (s) => s.incomingDecided || []
);

export const outgoingAccessRequestsSelector = createSelector(
  slice,
  (s) => s.outgoingPending || []
);

export const outgoingDecidedAccessSelector = createSelector(
  slice,
  (s) => s.outgoingDecided || []
);

export const pendingAccessForUsersSelector = createSelector(
  slice,
  (s) => s.pendingForUsers || []
);

/**
 * What the notification badge counts: the asks this owner can actually
 * act on right now. Outgoing requests are theirs to wait on, not to
 * decide, so they deliberately do not add to the badge.
 */
export const accessRequestBadgeCountSelector = createSelector(
  incomingAccessRequestsSelector,
  (pending) => pending.length
);
